import {
  login,
} from "../../../services/Auth/AuthService";

import {
  LOGIN_CONFIRMED_ACTION,
  LOGIN_FAILED_ACTION,
  LOADING_TOGGLE_ACTION,
  LOGOUT_ACTION,
  UPDATE_AUTH_USER,
} from "../types/AuthTypes";
import axiosInstance, { ACCOUNT_REVOCATION_MESSAGES } from "../../../services/AxiosInstance";
import { queryClient } from "../../../services/queryClient";

export function logoutAction(navigate) {
  return async (dispatch) => {
    try {
      await axiosInstance.post("/logout");
      queryClient.clear();
      dispatch({ type: LOGOUT_ACTION });
      navigate("/login");
    } catch (error) {
      // 401/403-revocation: the interceptor already cleared state and is navigating to /login.
      // Suppress the error to avoid a spurious toast over the interceptor's own message.
      if (error.response?.status === 401) return;
      if (error.response?.status === 403) {
        const msg = error.response.data?.error ?? '';
        if (ACCOUNT_REVOCATION_MESSAGES.some(m => msg.startsWith(m))) return;
      }
      throw new Error("Logout failed.");
    }
  };
}

export function loginAction (email, password, navigate) {
  return (dispatch) => {
    login(email, password)
      .then(response => {
        const user = response.data.user;
        dispatch(loginConfirmedAction({ user }));
        navigate("/");
      })
      .catch((error) => {
        if (error.response?.status === 401 && error.response.data?.reason === 'email-unverified') {
          const verifyEmail = error.response.data?.email || email;
          dispatch(loadingToggleAction(false));
          navigate(`/verify-email?email=${encodeURIComponent(verifyEmail)}`);
          return;
        }
        const errorMessage = error.response?.data?.error || 'Login failed. Please try again.';
        dispatch(loginFailedAction(errorMessage));
        dispatch(loadingToggleAction(false));
      });
  };
}

export function loginFailedAction (data) {
  return {
    type: LOGIN_FAILED_ACTION,
    payload: data,
  };
}

export function loginConfirmedAction ({ user }) {
  return {
    type: LOGIN_CONFIRMED_ACTION,
    payload: {
      user,
    },
  };
}

export function loadingToggleAction (status) {
  return {
    type: LOADING_TOGGLE_ACTION,
    payload: status,
  };
}

export function updateAuthUser (updatedUser) {
  return {
    type: UPDATE_AUTH_USER,
    payload: updatedUser,
  };
}

